import { useNavigate } from 'react-router-dom'
import { useTheme } from '../context/ThemeContext'

const UPDATED = '15 июня 2026 г.'

const sections = [
  {
    title: '1. Общие положения',
    body: [
      '1.1. Настоящее Пользовательское соглашение (далее - «Соглашение») регулирует отношения между Индивидуальным предпринимателем «Welland» (далее - «Оператор», «Правообладатель», «Мы») и физическим лицом, использующим веб-сервис Welland Create (далее - «Пользователь», «Вы»).',
      '1.2. Welland Create представляет собой веб-платформу для трехмерного проектирования бассейнов, подбора оборудования, формирования технических спецификаций, визуализации проектов и использования сопутствующих инструментов.',
      '1.3. Использование Сервиса означает полное и безоговорочное принятие Пользователем условий настоящего Соглашения.',
      '1.4. Если Пользователь не согласен с условиями настоящего Соглашения, он обязан прекратить использование Сервиса.',
    ],
  },
  {
    title: '2. Информация об Операторе',
    body: [
      'Оператор:\nИндивидуальный предприниматель «Welland»\n\nАдрес:\nРеспублика Казахстан, г. Алматы\n\nЭлектронная почта:\nwelland.info@mail.ru',
    ],
  },
  {
    title: '3. Регистрация и учетная запись',
    body: [
      '3.1. Для доступа к функциональности Сервиса Пользователь обязан создать учетную запись.',
      '3.2. Регистрация может осуществляться:\n\n• посредством адреса электронной почты и пароля;\n• посредством авторизации через учетную запись Google.',
      '3.3. Пользователь обязуется:\n\n• предоставлять достоверные сведения;\n• поддерживать актуальность предоставленных данных;\n• не использовать данные третьих лиц без законных оснований.',
      '3.4. Пользователь самостоятельно несет ответственность за сохранность своих учетных данных.',
      '3.5. Все действия, совершенные через учетную запись Пользователя, считаются совершенными самим Пользователем до момента уведомления Оператора о несанкционированном доступе.',
    ],
  },
  {
    title: '4. Возрастные ограничения',
    body: [
      '4.1. Использование Сервиса допускается лицами, достигшими 18 лет.',
      '4.2. Лица младше 18 лет могут использовать Сервис только с согласия родителей либо иных законных представителей.',
    ],
  },
  {
    title: '5. Порядок использования Сервиса',
    body: [
      '5.1. Пользователь вправе:\n\n• создавать проекты бассейнов;\n• сохранять и редактировать проекты;\n• формировать и скачивать спецификации;\n• использовать результаты работы Сервиса в информационных и профессиональных целях.',
      '5.2. Сервис предоставляется на безвозмездной основе, если иное не указано Оператором отдельно.',
    ],
  },
  {
    title: '6. Запрещенные действия',
    body: [
      'Пользователю запрещается:\n\n• нарушать законодательство Республики Казахстан;\n• использовать Сервис для противоправных целей;\n• предпринимать попытки несанкционированного доступа к Сервису;\n• распространять вредоносное программное обеспечение;\n• использовать автоматизированные средства сбора данных без письменного разрешения Оператора;\n• обходить технические ограничения Сервиса;\n• копировать программный код, алгоритмы, интерфейс или иные элементы Сервиса без согласия Правообладателя.',
    ],
  },
  {
    title: '7. Интеллектуальная собственность',
    body: [
      '7.1. Все права на программное обеспечение, дизайн, интерфейсы, алгоритмы, базы данных, логотипы, товарные обозначения и иные элементы Сервиса принадлежат Оператору либо используются им на законных основаниях.',
      '7.2. Пользователю предоставляется ограниченное неисключительное право использования Сервиса исключительно в рамках его функционального назначения.',
      '7.3. Параметры проектов, создаваемые Пользователем, остаются собственностью Пользователя.',
      '7.4. Пользователь предоставляет Оператору право хранить, обрабатывать и отображать созданные данные исключительно в целях функционирования Сервиса.',
    ],
  },
  {
    title: '8. Проекты и данные пользователей',
    body: [
      '8.1. Пользователь самостоятельно несет ответственность за сохранение экспортированных файлов, PDF-документов, спецификаций и иных результатов работы.',
      '8.2. Оператор не гарантирует бессрочное хранение проектов.',
      '8.3. В случае удаления учетной записи связанные проекты могут быть удалены вместе с учетной записью.',
    ],
  },
  {
    title: '9. Доступность сервиса',
    body: [
      '9.1. Сервис предоставляется по принципу «как есть» (As Is).',
      '9.2. Оператор не гарантирует:\n\n• бесперебойную работу Сервиса;\n• отсутствие ошибок;\n• абсолютную точность расчетов;\n• соответствие результатов конкретным задачам Пользователя.',
      '9.3. Оператор вправе временно ограничивать доступ к Сервису для проведения технических работ, обновлений и устранения неисправностей.',
    ],
  },
  {
    title: '10. Ограничение ответственности',
    body: [
      '10.1. Результаты расчетов, спецификации и рекомендации, формируемые Сервисом, носят информационный и рекомендательный характер.',
      '10.2. Пользователь самостоятельно принимает решения на основании полученных результатов.',
      '10.3. В максимально допустимой законодательством степени Оператор не несет ответственности за любые убытки, возникшие вследствие использования либо невозможности использования Сервиса.',
    ],
  },
  {
    title: '11. Сторонние сервисы',
    body: [
      '11.1. В работе Сервиса могут использоваться сторонние сервисы, включая сервисы авторизации Google и аналитические платформы.',
      '11.2. Использование таких сервисов регулируется условиями и политиками соответствующих владельцев.',
      '11.3. Оператор не несет ответственности за работу сторонних сервисов.',
    ],
  },
  {
    title: '12. Прекращение доступа',
    body: [
      '12.1. Пользователь вправе прекратить использование Сервиса в любое время.',
      '12.2. Оператор вправе ограничить или прекратить доступ Пользователя при наличии оснований полагать, что Пользователь:\n\n• нарушает настоящее Соглашение;\n• нарушает права третьих лиц;\n• нарушает требования законодательства.',
    ],
  },
  {
    title: '13. Международное использование',
    body: [
      '13.1. Сервис доступен пользователям из различных государств.',
      '13.2. Пользователь самостоятельно несет ответственность за соблюдение законодательства государства своего пребывания.',
    ],
  },
  {
    title: '14. Разрешение споров',
    body: [
      '14.1. Настоящее Соглашение регулируется законодательством Республики Казахстан.',
      '14.2. Стороны обязуются предпринимать меры для урегулирования споров путем переговоров.',
      '14.3. При невозможности урегулирования спор подлежит рассмотрению в судебных органах Республики Казахстан по месту нахождения Оператора.',
    ],
  },
  {
    title: '15. Изменение Соглашения',
    body: [
      '15.1. Оператор вправе вносить изменения в настоящее Соглашение.',
      '15.2. Новая редакция вступает в силу с момента публикации на Сайте, если иное не указано отдельно.',
      '15.3. Продолжение использования Сервиса означает принятие новой редакции Соглашения.',
    ],
  },
  {
    title: '16. Контакты',
    body: [
      'ИП «Welland»\nИИН: 970925300208\nАдрес: Республика Казахстан, г. Алматы\nТелефон / WhatsApp: +7 (777) 229-62-25\nE-mail: welland.info@mail.ru',
    ],
  },
]

export default function TermsPage() {
  const { dark } = useTheme()
  const navigate = useNavigate()

  const bg   = dark ? '#010810' : '#F0F5F9'
  const card = dark ? '#05111F' : '#FFFFFF'
  const line = dark ? 'rgba(255,255,255,.08)' : 'rgba(10,32,40,.09)'
  const text = dark ? 'rgba(255,255,255,.88)' : '#0A2028'
  const muted= dark ? 'rgba(255,255,255,.45)' : 'rgba(10,32,40,.5)'
  const head = dark ? '#fff' : '#0A2028'

  return (
    <div style={{
      minHeight: '100vh', background: bg,
      fontFamily: "'Plus Jakarta Sans',system-ui,sans-serif",
      WebkitFontSmoothing: 'antialiased',
      backgroundImage: dark
        ? 'radial-gradient(ellipse 70% 40% at 50% 0%,rgba(15,163,177,.1) 0%,transparent 70%)'
        : 'radial-gradient(ellipse 70% 40% at 50% 0%,rgba(15,163,177,.07) 0%,transparent 70%)',
    }}>
      {/* Nav */}
      <div style={{ borderBottom: `1px solid ${line}`, padding: '0 28px' }}>
        <div style={{ maxWidth: 860, margin: '0 auto', height: 60, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <button onClick={() => navigate(-1)} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            display: 'flex', alignItems: 'center', gap: 8, color: '#0FA3B1',
            fontSize: 13, fontWeight: 700, fontFamily: 'inherit', padding: 0,
          }}>
            ← Вернуться назад
          </button>
          <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 10, letterSpacing: '.18em', color: muted, textTransform: 'uppercase' }}>
            Welland Create
          </span>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '52px 28px 80px' }}>
        <div style={{ background: card, borderRadius: 20, border: `1px solid ${line}`, boxShadow: dark ? '0 24px 60px rgba(0,0,0,.4)' : '0 4px 24px rgba(10,32,40,.07)', overflow: 'hidden' }}>

          {/* Header */}
          <div style={{ padding: '44px 52px 36px', borderBottom: `1px solid ${line}`, background: dark ? 'rgba(15,163,177,.04)' : 'rgba(15,163,177,.03)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: 'rgba(15,163,177,.12)', border: '1px solid rgba(15,163,177,.25)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0FA3B1" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
              </div>
              <span style={{ fontFamily: "'JetBrains Mono',monospace", fontSize: 10, letterSpacing: '.2em', color: '#0FA3B1', textTransform: 'uppercase', fontWeight: 700 }}>Welland Create</span>
            </div>
            <h1 style={{ fontSize: 'clamp(22px,4vw,34px)', fontWeight: 900, color: head, letterSpacing: '-.025em', lineHeight: 1.1, margin: 0 }}>
              Пользовательское соглашение
            </h1>
            <p style={{ fontSize: 14, color: muted, marginTop: 10, lineHeight: 1.6 }}>
              Последнее обновление: <b style={{ color: text }}>{UPDATED}</b>
            </p>
            <div style={{ marginTop: 16, padding: '12px 16px', background: dark ? 'rgba(15,163,177,.08)' : 'rgba(15,163,177,.07)', borderRadius: 10, border: `1px solid ${dark ? 'rgba(15,163,177,.2)' : 'rgba(15,163,177,.18)'}` }}>
              <p style={{ fontSize: 13.5, color: text, lineHeight: 1.65, margin: 0 }}>
                Прочитайте настоящее Соглашение перед использованием Welland Create. Используя Сервис, вы принимаете изложенные здесь условия.
              </p>
            </div>
          </div>

          {/* Sections */}
          <div style={{ padding: '40px 52px 52px', display: 'flex', flexDirection: 'column', gap: 0 }}>
            {sections.map((s, i) => (
              <div key={i} style={{ paddingBottom: 32, marginBottom: 32, borderBottom: i < sections.length - 1 ? `1px solid ${line}` : 'none' }}>
                <h2 style={{ fontSize: 17, fontWeight: 800, color: head, marginBottom: 14, letterSpacing: '-.015em' }}>{s.title}</h2>
                {s.body.map((p, j) => (
                  <p key={j} style={{ fontSize: 14.5, color: text, lineHeight: 1.75, margin: j > 0 ? '12px 0 0' : 0, whiteSpace: 'pre-line' }}>{p}</p>
                ))}
              </div>
            ))}
          </div>

          {/* Footer */}
          <div style={{ borderTop: `1px solid ${line}`, padding: '20px 52px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
            <span style={{ fontSize: 12.5, color: muted }}>© 2025 Welland. Все права защищены.</span>
            <button onClick={() => navigate('/privacy')} style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: '#0FA3B1', fontSize: 13, fontWeight: 600, fontFamily: 'inherit', padding: 0,
            }}>
              Политика конфиденциальности →
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
